<template>
  <div class="table-responsive">
    <table
      class="table table-sm table-striped table-bordered fs-sm"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th class="text-center">#</th>
          <th>Cliente</th>
          <th>Solicitante</th>
          <th>Técnico</th>
          <th>Titulo</th>
          <th>Quadro</th>
          <th>Ultima Sinc.</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="ticket in tickets" :key="ticket.id">
          <td class="text-center">{{ ticket.ticketId }}</td>
          <td>{{ ticket.organization }}</td>
          <td>
            {{ ticket.requester }}
            {{
              ticket.requester !== ticket.requesterName
                ? `(${ticket.requesterName})`
                : ''
            }}
            <i
              v-if="!ticket.userContactId"
              class="ph ph-warning-circle text-warning"
            />
          </td>
          <td>{{ ticket.technicianName }}</td>
          <td>{{ ticket.summary }}</td>
          <td>{{ ticket.boardName }}</td>
          <td>
            <span class="d-none">{{ ticket.lastSync }}</span>
            {{ dateTimeSqlToDateTimeBR(ticket.lastSync) }}
          </td>
          <td class="text-center p-1">
            <button
              type="button"
              class="btn btn-outline-purple btn-icon"
              title="Visulizar Logs do Ticket"
              @click="$emit('showLogsTicket', ticket.ticketId)"
            >
              <i class="ph ph-clock-clockwise" />
            </button>
            <button
              type="button"
              class="btn btn-outline-primary btn-icon ms-2"
              title="Visualizar Detalhes do Ticket"
              @click="$emit('showDetailsTicket', ticket.ticketId)"
            >
              <i class="ph ph-file-text" />
            </button>
            <button
              v-if="!ticket.userContactId"
              type="button"
              class="btn btn-outline-success btn-icon ms-2"
              title="Vincular Contato ao Ticket"
              @click="$emit('showContactTicket', ticket.ticketId)"
            >
              <i class="ph ph-user" />
            </button>
            <button
              v-if="ticket.uuid"
              type="button"
              class="btn btn-outline-pink btn-icon ms-2"
              title="Verifica se há pesquisa"
              @click="$emit('showSurveysTicket', ticket.uuid)"
            >
              <i class="ph ph-seal-question" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'

export default {
  name: 'ListTickets',

  props: {
    tickets: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListTickets',
        columnDefs: [
          {
            targets: [7],
            orderable: false,
            width: 240,
          },
        ],
        order: [[0, 'desc']],
      },
      dateTimeSqlToDateTimeBR,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable(this.dataTable)
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
